<div class="entry-list row">
   
    <div *ngFor="let entry of featuredList; index as myCount" class="col-sm-6">
      <h3 class="title">
        <a routerLink="/blog/{{ entry.slug }}">{{ entry.title }}</a>
      </h3>
      <div class="px-2">
         {{entry.summary}}
         <a routerLink="/blog/{{ entry.slug }}">Read More</a>
        </div>
      <div class="published px-2 py-1"><i class="fa fa-calendar-o"></i> Published on {{ entry.date | date }}  <i class='fa fa-user'></i> Boldungu Team</div>
    </div>
  
  </div>
